import "./token.mjs";
import "ethers";
import "@deorderbook/contracts/abi";
import "../store/provider.mjs";
import "@deorderbook/contracts";
import { useERC20Contract as r } from "../store/erc20Contract.mjs";
import "../store/subgraph.mjs";
function f(t, o) {
  return r(t).balanceOf(o);
}
function b(t, o, n) {
  return r(t).allowance(o, n);
}
function s(t, o, n) {
  return r(t, !0).approve(o, n);
}
function v(t) {
  return r(t).totalSupply();
}
export {
  b as allowance,
  s as approve,
  f as balanceOf,
  v as totalSupply
};
//# sourceMappingURL=token_erc20.mjs.map
